(function(){
     'use strict';

     angular
        .module('app')
        .factory('PagosService', PagosService);

    PagosService.$inject = ["$http","$q","$window","$location"];

    function PagosService($http,$q,$window,$location){

        var pagos= {
           getFacturas:getFacturas,
           getCupon:getCupon
        };

 		function getFacturas(vm)
        {
            var config = {headers : {}}

            return $http.get('/ajax/resumenfacturas', {   
                params : { 
                    filtros:JSON.stringify(vm.filtros)
                }
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function getCupon(vm)
        {
            var config = {headers : {}}

            return $http.get('/ajax/cupon', {   
                  params : { 
                    filtros:JSON.stringify(vm.filtros)
                }
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        return pagos;
    }

})();